import React, { useEffect, useState } from "react";
import "./checkOut.scss";
import { Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { serviceCall } from "../../Utils/ServiceUtils";

function CheckOut() {
    const cartDetails = JSON.parse(localStorage.getItem("CartDetails"));
    const [formBody, setFormBody] = useState({
        Email: "",
        emailErr: false,
        FirstName: "",
        LastName: "",
        Phone: "",
        phoneErr: false,
        Street: "",
        City: "",
        State: "",
        Country: "",
        ZipCode: "",
    });
    const [totalPriceVal, setTotalPriceVal] = useState(0);  
    const handleInputChange = (e) => {
        e.preventDefault();
        const { id, value } = e.target;
        setFormBody((prev) => ({ ...prev, [id]: value }));
    }

    useEffect(() => {
        totalPrice(cartDetails);
    }, [])

    const handleInputBlur = (e) => {
        e.preventDefault();
        const { id, value } = e.target;
        let phoneRegex = new RegExp("^[0-9]*$");
        let emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        (id === "Phone") && setFormBody((prev) => ({ ...prev, "phoneErr": value.length > 0 && phoneRegex.test(value) ? false : true }));
        (id === "Email") && setFormBody((prev) => ({ ...prev, "emailErr": value.length > 0 && !emailRegex.test(value) ? true : false }));
    }

    async function totalPrice(data) {
        let price = 0;
        data.map((element) => (price = price + (element.Price * element.Quantity)))
        setTotalPriceVal(price);
    }

    const navigateToFormStep = (stepNumber) => {
        /**
         * Hide all form steps.
         */
        document.querySelectorAll(".form-step").forEach((formStepElement) => {
            formStepElement.classList.add("d-none");
        });
        /**
         * Mark all form steps as unfinished.
         */
        document.querySelectorAll(".form-stepper-list").forEach((formStepHeader) => {
            formStepHeader.classList.add("form-stepper-unfinished");
            formStepHeader.classList.remove("form-stepper-active", "form-stepper-completed");
        });
        /**
         * Show the current form step (as passed to the function).
         */
        document.querySelector("#step-" + stepNumber).classList.remove("d-none");
        /**
         * Select the form step circle (progress bar).
         */
        const formStepCircle = document.querySelector('li[step="' + stepNumber + '"]');
        /**
         * Mark the current form step as active.
         */
        formStepCircle.classList.remove("form-stepper-unfinished", "form-stepper-completed");
        formStepCircle.classList.add("form-stepper-active");
        /**
         * Loop through each form step circles.
         * This loop will continue up to the current step number.
         * Example: If the current step is 3,
         * then the loop will perform operations for step 1 and 2.
         */
        for (let index = 0; index < stepNumber; index++) {
            /**
             * Select the form step circle (progress bar).
             */
            const formStepCircle = document.querySelector('li[step="' + index + '"]');
            /**
             * Check if the element exist. If yes, then proceed.
             */
            if (formStepCircle) {
                /**
                 * Mark the form step as completed.
                 */
                formStepCircle.classList.remove("form-stepper-unfinished", "form-stepper-active");
                formStepCircle.classList.add("form-stepper-completed");
            }
        }
    };

    function stepUpNext(val) {
        const stepNumber = parseInt(val);
        navigateToFormStep(stepNumber);
    }

    const placeOrder = async () => {
        let userData = formBody;
        delete userData.emailErr;
        delete userData.phoneErr;
        let reqBody = {
            "OrderId": null,
            "Payment": "card",
            "CreatedOn": new Date(),
            "Status": "Pending",
            "UserData": userData,
            "CartProducts": cartDetails
          }
        const resp = await serviceCall("POST", "/API/Order/CreateOrder", reqBody);
        if (resp && (resp.cardPayment === true)) {
            const checkoutResp = await serviceCall("GET", "/API/Payments/CreateCheckoutSession");
            checkoutResp?.Url && window.open(checkoutResp.Url, "_self");
        }
      }

    return (
        <>

            <div className="checkOutForm">
                <div id="multi-step-form-container">
                    <ul className="form-stepper form-stepper-horizontal text-center mx-auto pl-0">
                        <li className="form-stepper-active text-center form-stepper-list" step="1">
                            <a className="mx-2">
                                <span className="form-stepper-circle">
                                    <span>1</span>
                                </span>
                                <div className="label">Shipping Address</div>
                            </a>
                        </li>
                        <li className="form-stepper-unfinished text-center form-stepper-list" step="2">
                            <a className="mx-2">
                                <span className="form-stepper-circle text-muted">
                                    <span>2</span>
                                </span>
                                <div className="label text-muted">Summary</div>
                            </a>
                        </li>
                        <li className="form-stepper-unfinished text-center form-stepper-list" step="3">
                            <a className="mx-2">
                                <span className="form-stepper-circle text-muted">
                                    <span>3</span>
                                </span>
                                <div className="label text-muted">Payment</div>
                            </a>
                        </li>
                        {/* <li className="form-stepper-unfinished text-center form-stepper-list" step="4">
                            <a className="mx-2">
                                <span className="form-stepper-circle text-muted">
                                    <span>4</span>
                                </span>
                                <div className="label text-muted">Successfull</div>
                            </a>
                        </li> */}
                    </ul>
                    <form id="userAccountSetupForm" name="userAccountSetupForm" >
                        <section id="step-1" className="form-step">
                            <h2 className="font-normal">Shipping Address</h2>
                            <div className="mt-3">

                                <div className="d-flex">
                                    <Form.Group className="mb-3 me-3 width_50" >
                                        <Form.Control
                                            type="text"
                                            autoComplete="off"
                                            placeholder="Fisrt Name"
                                            className="input"
                                            id="FirstName"
                                            onBlur={(e) => handleInputBlur(e)}
                                            onChange={(e) => handleInputChange(e)}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3 width_50" >
                                        <Form.Control
                                            type="text"
                                            autoComplete="off"
                                            placeholder="Last Name"
                                            className="input"
                                            id="LastName"
                                            onBlur={(e) => handleInputBlur(e)}
                                            onChange={(e) => handleInputChange(e)}
                                        />
                                    </Form.Group>
                                </div>
                                <div className="d-flex">
                                    <Form.Group className="mb-3 me-3 width_50">
                                        <Form.Control
                                            type="text"
                                            autoComplete="off"
                                            placeholder="Phone"
                                            className="input"
                                            id="Phone"
                                            onBlur={(e) => handleInputBlur(e)}
                                            onChange={(e) => handleInputChange(e)}
                                        />
                                        {formBody.phoneErr && <span className="fieldError">Enter a valid Number </span>}
                                    </Form.Group>
                                    <Form.Group className="mb-3 width_50">
                                        <Form.Control
                                            type="text"
                                            placeholder="Street"
                                            className="input"
                                            id="Street"
                                            onBlur={(e) => handleInputBlur(e)}
                                            onChange={(e) => handleInputChange(e)}
                                        />
                                    </Form.Group>
                                </div>
                                <div className="d-flex">
                                    <Form.Group className="mb-3 me-3 width_50" >
                                        <Form.Control
                                            type="text"
                                            autoComplete="off"
                                            placeholder="City"
                                            className="input"
                                            id="City"
                                            onBlur={(e) => handleInputBlur(e)}
                                            onChange={(e) => handleInputChange(e)}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3 width_50" >
                                        <Form.Control
                                            type="text"
                                            autoComplete="off"
                                            placeholder="State"
                                            className="input"
                                            id="State"
                                            onBlur={(e) => handleInputBlur(e)}
                                            onChange={(e) => handleInputChange(e)}
                                        />
                                    </Form.Group>
                                </div>
                                <div className="d-flex">
                                    <Form.Group className="mb-3 me-3 width_50">
                                        <Form.Control
                                            type="text"
                                            autoComplete="off"
                                            placeholder="Country"
                                            className="input"
                                            id="Country"
                                            onBlur={(e) => handleInputBlur(e)}
                                            onChange={(e) => handleInputChange(e)}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3 width_50" >
                                        <Form.Control
                                            type="text"
                                            autoComplete="off"
                                            placeholder="ZipCode"
                                            className="input"
                                            id="ZipCode"
                                            onBlur={(e) => handleInputBlur(e)}
                                            onChange={(e) => handleInputChange(e)}
                                        />
                                    </Form.Group>
                                </div>
                                <div className="d-flex">
                                    <Form.Group className="mb-3 me-3 width_50">
                                        <Form.Control
                                            type="email"
                                            autoComplete="off"
                                            placeholder="Email Address"
                                            className="input"
                                            id="Email"
                                            onBlur={(e) => handleInputBlur(e)}
                                            onChange={(e) => handleInputChange(e)}
                                        />
                                        {formBody.emailErr && <span className="fieldError">Invalid email address </span>}
                                    </Form.Group>
                                </div>
                            </div>
                            <div className="mt-3">
                                <button className="button checkoutbtn btn-navigate-form-step" type="button" step_number="2" disabled={formBody.FirstName.length === 0 || formBody.LastName.length === 0 || formBody.Phone.length === 0 || formBody.phoneErr === true || formBody.Street.length === 0 || formBody.City.length === 0  || formBody.State.length === 0 || formBody.Country.length === 0 || formBody.ZipCode.length === 0  || formBody.Email.length === 0 || formBody.emailErr === true} onClick={() => stepUpNext("2")}>Next</button>
                            </div>
                        </section>
                        <section id="step-2" className="form-step d-none">
                            <h2 className="font-normal">Order Summary</h2>
                            <div className="mt-3">
                                <div className="cartDetailsPage newpd">
                                    <div className="prdt-list">
                                        {cartDetails.length > 0 ? <span> {cartDetails.map((element, idx) => (
                                            <div key={idx} className="cart-item">
                                                <div className="cart-item-image">
                                                    <img src={element.ImageUrl} alt="Product" />
                                                </div>
                                                <div className="cart-item-details">
                                                    <h3>{element.Name}</h3>
                                                    <p>Price: {element.Price}</p>
                                                    <p>Quantity: <input type="number" min="1" className="form-control qtyInputBox" disabled={true} defaultValue={element.Quantity} /> </p>
                                                </div>
                                            </div>
                                        ))}
                                            <div className="cart-total">
                                                <h2>Total Price: {totalPriceVal}</h2>
                                            </div></span> : ""}
                                    </div></div>
                            </div>
                            <div className="mt-3">
                                <button className="button btn-navigate-form-step" type="button" step_number="1" onClick={() => stepUpNext("1")}>Prev</button>
                                <button className="button btn-navigate-form-step" type="button" step_number="3" onClick={() => stepUpNext("3")}>Next</button>
                            </div>
                        </section>
                        <section id="step-3" className="form-step d-none">
                            <h2 className="font-normal">Payment Method</h2>
                            <div className="mt-3">
                                <fieldset>
                                    {/* <legend></legend> */}
                                    <div className="form__radios">
                                        <div className="form__radio">
                                            <label htmlFor="cod">Card Payment</label>
                                            <input id="cod" name="payment-method" type="radio" defaultChecked />
                                        </div>
                                        {/* <div className="form__radio">
                                            <label htmlFor="visa">Visa Payment</label>
                                            <input id="visa" disabled={true} name="payment-method" type="radio" />
                                        </div>
                                        <div className="form__radio">
                                            <label htmlFor="paypal">PayPal</label>
                                            <input id="paypal" disabled={true} name="payment-method" type="radio" />
                                        </div>
                                        <div className="form__radio">
                                            <label htmlFor="mastercard">Master Card</label>
                                            <input id="mastercard" disabled={true} name="payment-method" type="radio" />
                                        </div> */}
                                    </div>
                                </fieldset>
                            </div>
                            <div className="mt-3">
                                {/* <button className="button btn-navigate-form-step" type="button" step_number="2" onClick={() => stepUpNext("2")}>Prev</button> */}
                                <button className="button btn-navigate-form-step" type="button" step_number="4" onClick={() => placeOrder()}>Proceed</button>
                            </div>
                        </section>
                        <section id="step-4" className="form-step d-none text-center" >
                            <h2 className="font-normal">Successfull</h2>
                            <div className="mt-3">
                                Order has been Placed Successfully.
                            </div>
                            <div className="mt-3">
                                <Link to="/Home" style={{ textDecoration: "none" }}>
                                    <button className="button submit-btn" type="submit">Home</button>
                                </Link>
                            </div>
                        </section>
                    </form>
                </div>
            </div>

        </>
    );
}

export default CheckOut;